module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-container"
  }, [_c('div', [_c('div', {
    staticClass: "account-tray"
  }, [_c('div', {
    staticClass: "account-header"
  }, [_c('div', [(_vm.user.pictureUrl) ? _c('img', {
    staticClass: "circle",
    attrs: {
      "src": _vm.user.pictureUrl
    }
  }) : _c('img', {
    staticClass: "circle",
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('str.ConnectYourSocialAccounts')))]), _vm._v(" "), _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "account-body"
  }, [_c('div', [_c('ul', {
    staticClass: "social-accounts"
  }, _vm._l((_vm.socialMedias), function(title, socialMediaKey) {
    return _c('li', {
      key: socialMediaKey,
      staticClass: "account"
    }, [_c('h3', {
      staticClass: "account-title"
    }, [_vm._v(_vm._s(title))]), _vm._v(" "), (_vm.getUserSocialMediaProfile(socialMediaKey)) ? _c('img', {
      staticClass: "profile-picture circle",
      attrs: {
        "src": _vm.getProfilePicture(socialMediaKey)
      }
    }) : _c('i', {
      staticClass: "social-profile-icon circle",
      class: _vm.socialMediaIcon(socialMediaKey)
    }), _vm._v(" "), _c('p', [(_vm.isConnected(socialMediaKey)) ? _c('a', {
      attrs: {
        "href": _vm.getProfileUrl(socialMediaKey),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]) : _vm._e()]), _vm._v(" "), (_vm.isConnected(socialMediaKey)) ? _c('a', {
      staticClass: "secondary-content",
      on: {
        "click": function($event) {
          _vm.unlinkAccount(socialMediaKey)
        }
      }
    }, [_c('img', {
      staticClass: "account-btn circle",
      attrs: {
        "src": require("../assets/icons/x.svg")
      }
    })]) : _c('a', {
      staticClass: "secondary-content",
      on: {
        "click": function($event) {
          _vm.linkAccount(socialMediaKey)
        }
      }
    }, [_c('img', {
      staticClass: "account-btn circle",
      attrs: {
        "src": require("../assets/icons/plus.svg")
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "account-footer"
  }, [_c('div', [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Close')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdc8b14","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileManagement.vue
// module id = 482
// module chunks = 0